module.exports = __webpack_public_path__ + "img/cf.bc478716.svg";